// ─── Nombre de PERSONNES — vocabulaire unique de toute la fonctionnalité ──
// Trois niveaux, du plus fin au plus large :
//   • recette : pour combien de personnes ses quantités sont écrites ;
//   • repas   : pour combien de personnes la composition est prévue, et pour
//               chaque recette qui la compose, combien de personnes elle sert ;
//   • menu    : chaque case (jour × plage) sert un repas à N personnes.
// Porté à l'identique de MoPCal-v3 services/repas.js:55-79.
//
// `portions` est l'ancien nom du champ de la recette : on le lit encore pour
// ne pas migrer la base (et parce que l'import Schema.org le remplit).
export function personnesRecette(r) {
  return Math.max(1, Number(r?.personnes ?? r?.portions) || 1);
}
export function personnesRepas(rp) {
  return Math.max(1, Number(rp?.personnes) || 1);
}
// Personnes servies par une case de menu. À défaut (menus d'avant l'évolution),
// on sert exactement ce pour quoi le repas est prévu.
export function personnesCase(c, repas) {
  return Math.max(1, Number(c?.personnes) || personnesRepas(repas));
}
export function nbPersonnesDe(config) {
  return Math.max(1, Number(config?.nbPersonnes) || 4);
}
